import axios from 'axios';
import { CURRENT_API_URL } from "../../Utils/Constants";
import notify from '../../Notifications/ToastifyActions';


function SalesDataService(token, data) {
    
    // id in productDetails is either a field called asin or a field called integerId
    return axios.post(`${CURRENT_API_URL}/sellerPartner/ViewAsinSalesData`, data, {
        
        headers: {
            'Authorization': token,
        }
    }).then( notify.NotifySuccess("Sales Data is getting generated.")).
        then(res => {
            return res.data;
        }).catch(() => {
            notify.NotifyError(" please try again later.");
            return false;
        });
}
export {
    SalesDataService,
}